import { PermALL } from '../../app/hooks/premissionScreen'
import { categoryMenuItem } from './categoryAll'
import { companyMenuItem } from './company'
import { customerMenuItem } from './customer'
import { generalMenuItem } from './general'
import { financeMenuItem } from './finance'
import { orderMenuItem } from './order'
import { reportMenuItem } from './report'
import { staffAccountMenuItem } from './staffAccount'
import { createItem } from '../../help'
import ROUTES from '../../routers/helpersRouter/constantRouter'
import { RiMoneyDollarBoxLine } from '@remixicon/react'
import { Perm_OfferToPay_View } from '../../app/hooks/premissionScreen'

const managers = {
  id: 'all-manager',
  // title: 'Quản lý',
  type: 'group',
  premissions: PermALL,
  children: [
    ...generalMenuItem,
    ...orderMenuItem,
    staffAccountMenuItem,
    ...financeMenuItem,
    customerMenuItem,
    ...companyMenuItem,
    ...categoryMenuItem,
    ...reportMenuItem
  ]
}

export default managers
